import * as _ from 'lodash'
import {CircularConfigBO} from "./CircularConfigBO"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic"

export class CircularConfigBOValidations {

    static ValidateEmptyFields(aBO: CircularConfigBO): Promise<void>{

        return new Promise<void>((resolve, error ) =>{
            // Validate Circular Config
            if (_.isEmpty(aBO.WB_CircularConfig.cif.CONFIG_ID) || _.isNull(aBO.WB_CircularConfig.cif.CONFIG_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'configid',
                        title: "Circular Config ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('configid')
            }

            if (_.isEmpty(aBO.WB_CircularConfig.cif.CONFIG_NAME) || _.isNull(aBO.WB_CircularConfig.cif.CONFIG_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'configname',
                        title: "Circular Config Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('configname')
            }

            resolve()

        })

    }
}